<template>
  <div id="location" class="bg-cream">
    <div
        v-for="(location, index) in locations"
        :key="index"
    >
      <div class="flex flex-col md:flex-row px-6 mx-auto md:w-5/6 lg:w-3/4 xl:w-3/5 pt-20 text-gray-700"
           v-if="index % 2 === 0">
        <div class="md:w-2/5 pr-6 flex text-primary texto-roboto">
          <div>
            <p class="font-bold text-5xl line120">{{ location.title }}</p>
            <p v-if="location.title==='Theo Fritsche,'">Schul- & Hilfsprojekte</p>
            <p class="text-3xl font-light">{{ location.subtitle }}</p>
            <div class="map py-8">
              <img :src="require('../../assets/images/location/map' + (index + 1) + '.png')"/>
            </div>
          </div>
        </div>

        <div class="lg:border-l border-opacity-50 border-primary md:w-3/5 md:pl-12">
          <p class="text line170 texto-roboto font-regular">{{ location.text }}</p>
          <div v-if="location.title==='Child Africa'">
            <img
                class="pt-10 object-contain w-full md:w-auto"
                src="../../assets/images/location/childafrica.png"
            />
          </div>
          <div class="website pt-10 flex item-start">
            <img class="pr-3 self-start" src="../../assets/images/location/world.svg" alt/>

            <p class="visit p">
              You can visit {{ location.title }}'s website for more information
              <a target="_blank"
                 class="text-blue-400"
                 :href="location.web">here.</a>
            </p>
          </div>
        </div>
      </div>
      <div class="flex flex-col-reverse md:flex-row px-6 mx-auto md:w-5/6 lg:w-3/4 xl:w-3/5 pt-20 text-gray-700"
           v-else>
        <div class="lg:border-r border-opacity-50 border-primary md:w-3/5 md:pr-12">
          <p class="text line170 texto-roboto font-regular">{{ location.text }}</p>
          <div v-if="location.title==='Child Africa'">
            <img
                class="pt-10 object-contain w-full md:w-auto"
                src="../../assets/images/location/childafrica.png"
            />
          </div>
          <div class="website pt-10 flex item-start">
            <img class="pr-3 self-start" src="../../assets/images/location/world.svg" alt/>

            <p class="visit p">
              You can visit {{ location.title }}'s website for more information
              <a target="_blank"
                 class="text-blue-400"
                 :href="location.web">here.</a>
            </p>
          </div>
        </div>
        <div class="md:w-2/5 md:pl-6 flex text-primary texto-roboto">
          <div>
            <p class="font-bold text-5xl line120">{{ location.title }}</p>
            <p v-if="location.title === 'Theo Fritsche,'">Schul- & Hilfsprojekte</p>
            <p class="text-3xl font-light">{{ location.subtitle }}</p>
            <div class="map py-8">
              <img :src="require('../../assets/images/location/map' + (index + 1) + '.png')"/>
            </div>
          </div>
        </div>
      </div>
      <img v-show="index !== locations.length - 1"
           v-if="index === 1"
           class="w-screen mt-24"
           :src="index < locations.length - 1 ?
          require('../../assets/images/location/divider3.jpg')
          :
          null"
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "Location",
  data: () => ({
    locations: [
      {
        title: "Child Africa",
        subtitle: "Uganda",
        map: "../../assets/images/location/map1.png",
        web: "https://www.childafrica.org/",
        text:
            "Since 1991 Child Africa is a non-profit organization dedicated to help disadvantaged children in East Africa to enhance their lives through education. With support from sponsors such as the GoldenRace Foundation they help hundreds of children in Uganda with food, clothing, medicine, education and others."
      },
      {
        title: "Kibera Celtic Foundation",
        subtitle: "Kenya",
        map: "../../assets/images/location/map2.png",
        web: "https://www.facebook.com/kibera67/",
        text:
            "Ten years ago this school started a football team project to give hope to the poorest kids in the region. Thanks to this initiative some of the best students have been supported through education to learn and change their futures. They go to school during the teaching period and then, during holidays, they practise several sports."
      },
      {
        title: "Theo Fritsche,",
        subtitle: "Nepal",
        map: "../../assets/images/location/map3.png",
        web: "https://www.theofritsche.at/",
        text:
            "Theo Fritsche is an extreme mountaineer and entrepreneur from Vorarlberg who discovered Nepal and wanted to give something back to the country. Since he founded the Theo Fritsche schul- und hilfsprojekte in 2014 he has financed three schools nearly completely on his own. Thanks to this, about 1,000 children have had the opportunity to achieve a qualified school certificate. He also funds hospital construction projects to provide the community with health facilities. "
      },
      {
        title: "Njoro Primary School,",
        subtitle: "Tanzania",
        map: "../../assets/images/location/map4.png",
        web: "http://shulezetu.com/primary-schools/njoro-primary-school-p0703024/",
        text: "Njoro is a public primary school, Government owned, and placed in the rural area of Moshi. It daily receives around 800 children, aged 6 to 12 years, belonging to families in need. They are all very good students that the GoldenRace Foundation supports with social and academic help."
      }
    ]
  })
};
</script>

<style>
</style>